export { default as ListadoVentas } from "./Listado";
export { default as DetalleVenta } from "./Detalle";
export { default as GraficaVentas } from "./Grafica";
